import { Inject, Injectable } from '@angular/core';
import { AuthenticationObservableFactory } from '@/app/platform/platform-core/user/factories/types';
import { interval, Observable } from 'rxjs';
import {
  AUTHENTICATION_REFRESHER,
  AuthenticationRefresher,
  ValidAuthentication
} from '@/app/platform/platform-core/user/services/types';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Result, ValidResult } from '@common/result/Result';
import { ErrorInformation } from '@shared/models/error/error-information';
import { environment } from '@/environments/environment';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';

@Injectable({
  providedIn: 'root'
})
export class JwtAuthenticationObservableFactory implements AuthenticationObservableFactory {
  constructor(
    @Inject(AUTHENTICATION_REFRESHER)
    private readonly authenticationRefresher: AuthenticationRefresher
  ) {}

  create(): Observable<ValidAuthentication> {
    const refresher = interval(environment.auth.refreshTokenIntervalMS).pipe(
      mergeMap(() =>
        fromPromise(
          // Transiënte fouten (netwerk/5xx, bv. tijdens een deploy) breken de sessie
          // niet: tick overslaan en bij het volgende interval opnieuw proberen. Enkel
          // een expliciet ongeldige refresh (InvalidResult, bv. 401) logt uit via de
          // error-tak hieronder.
          this.authenticationRefresher.refresh().then(
            result => result,
            () => undefined
          )
        )
      ),
      filter((result): result is Result<ValidAuthentication, ErrorInformation> => result !== undefined),
      map(result => {
        if (result instanceof ValidResult) {
          return result.value;
        }

        throw result.errors[0];
      })
    );

    return refresher;
  }
}
